import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsShowpadComponent } from './simple-icons-showpad.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsShowpadComponent ],
    exports:      [ SimpleIconsShowpadComponent ],
    bootstrap:    []
})
export class SimpleIconsShowpadModule {}
